module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/005TOC#chapter_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Police Came Knocking")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")])]), _vm._v("t eight o’clock on a blustery Wednesday night in January 2001, two detectives from the state police knocked sharply on the door of Amy Gleason’s home. Amy had just returned from a twelve-hour shift at the hospital and was wearily and mechanically preparing her supper. The two men were impressively large, and the atmosphere quickly turned confrontational as they introduced themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“The state police were at my front door—so, stupidly, I invited them in,” Amy explained to me several years after that fateful day. “Since then, I’ve learned a hundred things about police detectives. First of all, don’t be in a hurry to invite them into your house, and second, you shouldn’t go downtown with them when they ask you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("After walking into Amy Gleason’s cheerful, cranberry-colored kitchen with its bleached maple cabinets, the two men politely "), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("refused to sit down. They quickly glanced around the room before turning their attention back to Amy.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“There’s been a death,” one of them somberly announced, pausing and leaving a strange emptiness in the air after the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("death")]), _vm._v(". The only thing Amy could think was that it must have been someone close to her. Her husband was at work, and she immediately thought of him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“What happened to my husband?” she whimpered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A look of confusion stretched across their faces, and they stared at Amy as if she had two heads.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“What do you mean, what happened to your husband?” they mumbled back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Well, you just told me that somebody died!” she choked out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It wasn’t your husband,” they said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Instant relief, but suddenly her pulse began to race as she thought about her elderly father.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Did my father die?” she gasped, wondering why else the state police would be at her house.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No,” they responded, continuing to be vague about why they were now standing in her kitchen. The strange dance of questions and answers went on for a while with Amy still unaware of what had brought these detectives to the house. Towering over her, they asked Amy if she worked at Baystate Medical Center. She confirmed that she was a nurse on Wesson 3, the hospital’s renal unit. The detectives then asked if she knew someone named Rosemarie Doherty. Amy gazed at the men blankly for a moment as she tried to remember where she had heard the name.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“At first I had no idea who they were talking about,” she later recalled when I spoke to her, “but then I realized that Rosemarie Doherty was the patient of another nurse, Kim Hoy. Honestly, I had had so little interaction with Mrs. Doherty that I hardly knew her name. I told them, ‘Oh, yes, she passed away.’”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The two officers looked at her as though waiting for her to fill in the blank that they’d provided.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Does that mean anything to you?” they finally asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Amy laughed kind of nervously at the question.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Oh, that happens all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Sitting back, years removed from that night, Amy contemplated those words.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Something else I’ve learned is that when state police detectives are in your home, another thing not to say is that deaths happen all the time. That is a very, very bad thing to say. But I still did not have a clue as to what they were talking about. Maybe I was just totally naive, but I had no idea they were going to be accusing me of murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("As Amy was learning what not to say to police officers, her fellow nurse Kim Hoy remained completely ignorant of the furor that would soon envelop her own life. Only after the state police were completely finished interviewing Amy were they going to pay her a visit. During my own subsequent interviews when I asked Kim to tell me about Rosemarie Doherty, I was shocked to watch her usually animated, intimate, and charming self instantly transformed into that of a vulnerable and frightened young woman. My conversations with Kim on this subject were always an emotional roller coaster. Most of the time we smiled at each other as she bubbled along, and then all of a sudden she would metaphorically, or in some instances literally, grab hold of my arm and I would feel as if we were uncontrollably falling. Her account of Rosemarie Doherty’s last hospitalization began with one of those horrible descents into despair.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("“I called her Rosie,” she said, waiting a beat to let the name sink in. “She was so sick. She had been on dialysis for a while, and was septic, had vascular disease, diabetes, and emphysema. She had a bedsore ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("which we were packing with dressings that took up her whole butt. Both of her heels were necrotic. Basically, she was rotting. Yes, there is no other way to say it. She was rotting.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I had taken care of Rosie off and on,” Kim said. “During this particular admission to the renal unit, I was her primary nurse for the first part of the week. I had a couple of days off, and then came back for the weekend. There had been active discussion about her becoming a DNR [do not resuscitate]. Although Rosie had periods in which she was more awake and seemingly alert, she was never fully oriented or coherent. Rosie recognized her children during their visits, but otherwise she was not cognizant of what was going on around her. She was terribly uncomfortable, and it was absolutely awful. I returned on the weekend, and the decision had been made during the previous night for her to be DNR and to receive comfort measures only. She would also no longer be going for dialysis treatments.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It was apparent to me that Kim not only cared for this severely ill woman’s physical problems but also cared for her emotionally. While some staff can’t help distancing themselves when a patient is physiologically and cognitively deteriorating, Kim remained tightly connected and committed to Rosie. Kim could not have imagined that her motives and nursing practices would be questioned, and that the police were going to knock on her door, too.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("The detectives’ visits to Kim and Amy had been set in motion several weeks earlier. A nurse’s aide, Olga Vasquez, had returned home convinced that she had witnessed a monstrous act—there was no doubt in her mind she had seen a woman being murdered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("For some time Olga had been feeling progressively more uncomfortable with the treatment provided to one of her patients, Rosemarie Doherty, who had been staying at Baystate Medical Center. To begin with, the family and the doctors decided to stop offering ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("dialysis, which meant she was going to die within a few days. On top of that, the primary nurse was Kim Hoy—a nice enough young woman, but one whose sense of propriety and boundaries appeared increasingly questionable to Olga. It was bad enough that Kim was prone to plunking herself down in bed alongside patients and reading them stories, but in Rosemarie Doherty’s case, Olga felt Kim’s behavior had been especially egregious. The patient was obviously having difficulty breathing; however, every time Olga turned on her oxygen, Kim would rush in and rip off the tubes and deliver a stinging rebuke about how the oxygen was not helpful. Olga became further convinced something was awry when on one such occasion Kim threw the plastic nasal cannula administering the oxygen on the floor and kicked it to the side. A few minutes later, Olga believed she saw Kim surreptitiously pick it up and conceal it in her uniform pocket.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("These incidents were bad, but the final straw was the morphine. Olga carefully observed Kim and the senior nurse from the renal unit, Amy Gleason, taking opiate medication from the mechanical dispenser on the nursing floor. It was obvious to Olga that they took more than had been prescribed, and she was appalled to watch Kim inject the excessive amount into Rosemarie’s drowsy body. Earlier in the shift, Olga had been horrified to hear Kim whispering to Rosemarie, “It is all right if you go now…. You don’t have to hang on any longer.” Accordingly, it came as no surprise to the nurse’s aide when the poor lady quietly expired.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("The irony of the situation was that Olga genuinely liked Amy Gleason and Kim Hoy. She had worked with them for a number of years and felt especially close to Kim, as they each had young children whose shenanigans were always an entertaining subject of conversation. Nonetheless, Olga was convinced she had glimpsed a dreadful and otherwise hidden aspect to Kim Hoy. Olga’s faith and her personal beliefs left no room to ignore a crime, and she told her ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("husband what she had seen. They promptly went to their lawyer and then to the district attorney’s office. These visits took place at a moment in the winter of 2001, when many people in western Massachusetts were deeply preoccupied with the trial of Kristen Gilbert, a nurse from the Northampton Veterans Affairs Medical Center who had been accused of being a serial killer.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("In the United States, it is not unusual at some point for doctors to shift from curative care, which focuses on healing people, to palliative care with its emphasis on the relief of symptoms and discomfort of dying. But within this seemingly simple change lie a host of issues with medical, political, and religious ramifications. There is also no clean, impersonal, and easy way to effect this change—there is no computer that a doctor simply turns off, no magic switch that gets thrown, no timer that runs out. It usually falls upon a nurse to go to the bedside and carry out a series of actions and complicated communications that allow the patient to die in as comfortable a manner as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("I am a physician specializing in palliative medicine and end-of-life issues. I have given presentations on these subjects at conferences around the world, but it was not until I came face-to-face with Amy Gleason, Kim Hoy, and Olga Vasquez that I completely understood the passions and the stakes of this work. Like Amy, Kim, and Olga, I work at Baystate Medical Center with patients who have kidney failure. Like these nurses, I have seen patients struggle to live when there is no hope of recovery.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("However, unlike Amy, Kim, and Olga, I have been relatively insulated from the act of dying, having personally witnessed only a couple of deaths. The same can be said for many doctors, revealing the largely ignored truth that physicians are rarely present when people die. Instead, it is nursing staff who are frontline combatants when death arrives. Amy and her colleagues at Baystate Medical ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Center have each ministered to scores, if not hundreds, of people as they took their final breaths. It may seem like hyperbole, but I believe really good nurses inherit the Crimean War legacy of Florence Nightingale, dispensing mercy at every battle. During my interviews with these and other nurses from my hospital, I came to marvel not only at their firsthand knowledge but also at their honesty and mordant sense of the ridiculous that allows them to adapt and even flourish in our pain-filled setting. Nurses see the suffering, the struggles to be cured, the families’ anguish, and the denial, resignation, or acceptance when death is inevitable. Pulling the plug—a rather inelegant phrase—is a complex process that forces nurses to draw upon their empathy, personal convictions, religious beliefs, and professional training.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Not only are nurses often present at the terminus of life, but they invariably spend more time with dying patients than do doctors, and this places them at risk for attack when something goes wrong or gives the appearance of having gone wrong. Accusations against all medical professionals are serious, but with nurses they are exquisitely personal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Still what happened between Amy, Kim, and Olga was not merely an accusation of malpractice or oversight. It was not about faulty clinical treatment or professionals falling asleep at the wheel. It was a manifestation of a far more serious matter, and one that repeatedly surfaces and informs conversations and debates all across America. If you haven’t already participated in a decision to withhold or withdraw treatment from a loved one, sooner or later you are going to be faced with this dilemma. If you haven’t already figured out your personal degree of comfort or discomfort over easing terminal symptoms at the expense of shortening people’s lives, you are inevitably going to be forced to make this discovery.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Having conducted several research studies and written numerous academic articles, I thought that I knew a great deal about ending ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("the life support of dialysis and vigorously providing pain medicines. I thought that I had overcome my reticence as an American to think and talk about death. But I was totally unprepared when these three staff members described Rosemarie Doherty’s last hospitalization and how their disagreement over her care led to a formal allegation and investigation of murder. Like most people at Baystate, I had never previously heard of this highly confidential and largely secret incident. I didn’t have a clue that such cases were also occurring in other hospitals around the country and around the world. And I didn’t know anything about the philosophical conflict that underlies each of these cases.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Since uncovering the Baystate nurses’ story, I have been able to interview a number of other accused medical staff, including Sharon LaDuke, who was fired from her position as nursing director of a rural intensive care unit after being accused of euthanasia; Dr. Robert Weitzel, who was convicted of manslaughter and sentenced to fifteen years in prison; and Dr. Lloyd Stanley Naramore, who was found guilty of attempted murder and intentional and malicious second-degree murder, and sentenced to concurrent terms of five to twenty years in a maximum-security prison.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("I have also talked to others—on both sides of this issue—who are working to further their beliefs and causes. I have sought to understand the cases in a nuanced manner and have approached disability activists, religious leaders, health care authorities, political scientists, and bioethicists. I have also paid considerable attention to the crucial role of law enforcement, which has its own reasons for seriously attending to accusations. In the end, I have weighed all these different perspectives and sought to understand the broader context for the confrontations that occur between the proponents and opponents of palliative medicine. And I have decided that it is absolutely crucial for me to communicate how these conflicts can tragically mangle the lives of some of our finest caregivers.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54eb1b29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007chapter01.vue
// module id = 75
// module chunks = 0